require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-choose-a-stack-part-1-python.json") })
        }
      }, "path---blog-how-to-choose-a-stack-part-1-python");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-choose-a-stack-part-1-python!./.cache/json/blog-how-to-choose-a-stack-part-1-python.json
// module id = 850
// module chunks = 231608221292675